import { render, staticRenderFns } from "./EModalEncerrarCaso.vue?vue&type=template&id=19d4d74c"
import script from "./EModalEncerrarCaso.vue?vue&type=script&lang=js"
export * from "./EModalEncerrarCaso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports